import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

export default function CleaningRoundSuccess() {
  return (
    <div style={{ maxWidth: "650px", margin: "120px auto", background: "#fff", padding: "40px", borderRadius: "12px", textAlign: "center" }}>
      <FaCheckCircle size={80} color="#2e7d32" />
      <h1 style={{ color: "#2e7d32" }}>Cleaning Round Listed Successfully!</h1>
      <p>Your cleaning round is now live and accepting enquiries.</p>

      <Link to="/cleaning/rounds">
        <button style={{ background: "#2e7d32", color: "#fff", padding: "12px", marginRight: "10px" }}>
          View Cleaning Rounds
        </button>
      </Link>

      <Link to="/cleaning/rounds/create">
        <button style={{ background: "#555", color: "#fff", padding: "12px" }}>
          Create Another
        </button>
      </Link>
    </div>
  );
}
